module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Khalid_Green.79761f2a.png";